import { LogFields, LoggerLogLevel, LogMessage, LogSchemaInterface } from '../types';

export class DefaultLogSchema implements LogSchemaInterface {
  level: LoggerLogLevel = 'trace';
  message: LogMessage = {
    scope: 'App',
    message: '',
  };
  errorMsg?: string | undefined;
  logData?: string | object;

  set msg(value: string) {
    this.message.message = value;
  }

  set scope(value: string) {
    this.message.scope = value;
  }

  toRecord(): Partial<Record<LogFields, unknown>> {
    return {
      logData: this.logData,
      errorMsg: this.errorMsg,
    };
  }
}
